<template>
  <div>
    <span @click="toggle">
      <slot :is-open="internalOpen" name="header" />
    </span>
    <slot v-if="internalOpen" name="content" />
  </div>
</template>

<script>
export default {
  name: 'ToggleItem',
  props: {
    open: {
      default: false,
      type: Boolean
    }
  },
  data: function () {
    return {
      internalOpen: this.open
    }
  },
  watch: {
    open() {
      this.internalOpen = this.open
    }
  },

  methods: {
    toggle() {
      this.internalOpen = !this.internalOpen
      this.$emit('toggle', this.internalOpen)
    },
    close() {
      this.internalOpen = false
    }
  }
}
</script>
